export default {
    methods: {
        localize(field_name) {
            let field = field_name + '_' + this.$i18n.locale;
            return field;
        }
    }
};


// WEBPACK FOOTER //
// ./src/mixins/translatorMixin.js